module.exports = __webpack_public_path__ + "static/medgrocer-81341621f06e4c5345064de1ae911f03.png";